import styled from 'styled-components';

export const Container = styled.div`
    display: flex;

    align-items: center;
    justify-content: center;
    
    width: 100%;
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 5rem;
    width: 70%;
    max-width: 800px;

    .update-profile {
        width: 20%;
        display: flex;
        align-items: center;
        justify-content: center;
        text-decoration: none;
        color: black;

        button {
            display: flex;
            border: none;
            background: none;
            align-items: center;
            justify-content: center;
            color: #333333;
            font-size: small;
        }
    }
`;

export const ProfileCard = styled.div`
    display: flex;
    flex-direction: COLUMN;
    align-items: center;
    justify-content: center;

    margin: 1rem;
    width: 100%;
    
    .profile-box {
        display: flex;
        width: 80%;
        flex-direction: row;
        align-items: center;
        justify-content: left;
    }
    .profile-box-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 1rem;
    }

    img {
        height: 80px;
        width: 80px;
        border-radius: 50%;
        margin-top: .6rem;
    }
`;

export const Button = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    color: white;
    font-family: Inter;
    font-weight: bold;
    font-size: large;
    background-color: black;
    padding: 1rem 1rem;
    margin: 4rem 0rem;
    border-radius: 20px;
`;

export const InfoCard = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin: 1rem 0rem;
    padding: .6rem 2rem;
    background-color: white;
    border-radius: 10px;

    .info-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 4rem;
    }
    .category {
        color: #7B6F72;
        margin: .2rem 0rem;
    }

`;

export const ProfileActivity = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: white;
    border-radius: 10px;


    .switchContent {
        display: flex;
        align-items: end;
        justify-content: space-between;
        width: 100%;
        padding: .5rem 1rem;

        .iconGroup {

            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;

            .iconGroupTitle {
                display: flex;
                align-items: end;
                justify-content: center;
                margin: 0rem .5rem;
            }
        }
    }

    .category {
        color: #7B6F72;
        margin: .2rem 0rem;
    }

`;

export const UploadContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 2rem;

    align-items: center;
    justify-content: center;

    form {
        margin: 1rem;
    }
    button {
        height: 2em;
        width: 200px;
        margin: 1rem 0rem;
        border-radius: 5px;
    }
`;